"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("@/api/class/ApiData"));
const oldApi = {
    getToken: new ApiData_1.default({
        name: '获取老系统token',
        url: 'web/user/getOldToken',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    findContract: new ApiData_1.default({
        name: '合同号查询',
        url: 'web/index/findContractPage',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
};
exports.default = oldApi;
